import { ColumnDef } from '@tanstack/react-table';

import { TooltipString } from '@/components/atoms/TooltipString';
import { PositionTrainingMatrixType } from '@/types/PositionTrainingMatrix';

export const positionColumn: Array<
	ColumnDef<
		| PositionTrainingMatrixType
		| {
				isSpecial: boolean;
				type: string;
		  }
	>
> = [
	{
		accessorKey: 'management',
		meta: {
			stickyClassName: 'sticky left-0 bg-white z-10 py-0 h-12',
			headerClassName: 'w-[12rem] bg-white z-20 sticky left-0',
		},
		header: '',
		cell: (info) => {
			const value = info.getValue() ? (info.getValue() as string) : '';
			switch (info.row.index) {
				case 0:
					return <div className="-ml-1 size-[104%] bg-white"></div>;
				case 1:
					return <div className="-ml-1 size-[104%] bg-white"></div>;
				case 2:
					return <div className="-ml-1 size-[104%] bg-white"></div>;
				case 3:
					return (
						<div className="top-0 z-10 flex h-[3.4rem] items-center justify-center overflow-x-hidden bg-blue-200 text-base duration-200">
							GERÊNCIA
						</div>
					);

				default:
					return (
						<div className="flex h-12 w-[12rem] items-center justify-start overflow-x-hidden px-2">
							<TooltipString
								value={value.toUpperCase()}
								color="black"
								fontSize="11px"
							/>
						</div>
					);
			}
		},
	},
	{
		accessorKey: 'areaCoordination',
		meta: {
			stickyClassName: 'sticky left-[12rem] bg-white z-10 py-0 h-12',
			headerClassName: 'min-w-[12rem] bg-white z-20 sticky left-[12rem]',
		},
		header: '',
		cell: (info) => {
			const value = info.getValue() ? (info.getValue() as string) : '';
			switch (info.row.index) {
				case 0:
					return <div className="-mb-1 h-full bg-white"></div>;
				case 1:
					return <div className="-mb-1 h-full bg-white"></div>;
				case 2:
					return '';
				case 3:
					return (
						<div className="top-0 z-10 flex h-[3.4rem] items-center justify-center overflow-x-hidden bg-blue-200 text-base duration-200">
							COORDENAÇÃO
						</div>
					);
				default:
					return (
						<div className="flex h-12 w-[12rem] items-center justify-start overflow-x-hidden px-2">
							<TooltipString
								value={value.toUpperCase()}
								color="black"
								fontSize="11px"
							/>
						</div>
					);
			}
		},
	},
	{
		accessorKey: 'name',
		meta: {
			stickyClassName: 'sticky left-[24rem] bg-white z-10 py-0 h-12',
			headerClassName: 'min-w-[12rem] sticky left-[24rem] z-20 bg-white',
		},
		header: () => {
			return (
				<div className="flex h-8 items-center justify-center font-graphie text-[13px]">
					<span>FUNÇÃO / CURSO</span>
				</div>
			);
		},
		cell: (info) => {
			const value = info.getValue() ? (info.getValue() as string) : '';
			switch (info.row.index) {
				case 0:
					return (
						<div className="flex h-12 items-center justify-center bg-blue-700 px-2 font-graphie text-[12px] text-white">
							VALIDADE (anos)
						</div>
					);
				case 1:
					return (
						<div className="flex h-12 items-center justify-center bg-blue-700 px-2 font-graphie text-[12px] text-white">
							CARGA HORÁRIA TOTAL (H)
						</div>
					);
				case 2:
					return (
						<div className="flex h-12 items-center justify-center bg-blue-700 px-2 font-graphie text-[12px] text-white">
							CARGA HORÁRIA RECICLAGEM (H)
						</div>
					);
				case 3:
					return (
						<div className="top-0 z-10 flex h-[3.4rem] items-center justify-center overflow-x-hidden bg-blue-200 text-base duration-200">
							FUNÇÃO
						</div>
					);
				default:
					return (
						<div className="flex h-12 w-[12rem] items-center justify-start overflow-x-hidden px-2">
							<TooltipString
								value={value.toUpperCase()}
								color="black"
								fontSize="11px"
							/>
						</div>
					);
			}
		},
	},
];
